import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Buttons from '../../components/Buttons';
import SummaryContent from '../../components/SummaryContent';
import { SequencingWizardContext } from '../../SequencingWizardContext';

const RemoveStep5 = props => {
  const { next, prev } = props;
  const {
    data: { changeList },
  } = useContext(SequencingWizardContext);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
        }}
      >
        <Box mb={0} mt={3} mx={3} textAlign="center">
          <Typography
            sx={{
              marginBottom: '16px',
            }}
            variant="h6"
          >
            Confirm Removal
          </Typography>
          <Typography
            sx={{
              marginBottom: '16px',
            }}
          >
            The selected Inventory Owners will be <u>removed</u> from any sequencing for the
            following locations and products.
          </Typography>
          <Typography
            sx={{
              marginBottom: '16px',
            }}
          >
            There could be a total of {changeList.length} change{changeList.length > 1 ? 's' : ''}.
            This change can take up to 15 minutes to take affect at all locations.
          </Typography>
        </Box>
        <SummaryContent inventoryOwnerSubtitle="Selected Inventory Owner" />
      </Box>
      <Buttons
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        rightLabel="Continue"
      />
    </>
  );
};

RemoveStep5.propTypes = {
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};

export default RemoveStep5;
